// 调账

import { HttpBillTaskList, HttpAdjustOne, HttpTaskBatchApprove, HttpTaskBatchImport } from '@/service/costbilling';
import TableList from "@components/templates/tablelist";
import compUpdate from './detaildoc'
import compFule from './detailfule'
import compPod from './pod.vue'
import compDown from './downfile'
import { mapGetters } from 'vuex';
export default {
    mixins: [TableList],
    components: {
        compUpdate,
        compDown,
        compFule,
        compPod
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            // Tabs: {show: true},
            formData: {},
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
            taskStatusList:[
                {value:0,label:'待下载'},
                {value:1,label:'下载中'},
                {value:2,label:'下载异常'},
                {value:3,label:'下载完成'},
                {value:4,label:'导入中'},
                {value:5,label:'导入异常'},
                {value:6,label:'导入完成'},
            ],
        };
    },
    methods: {
        ajaxRequest: HttpBillTaskList,
        getOperateNodeMap(row) {
            const { id,type } = row;
            // console.log(row.type)
            return [
                {
                    label: "审核",
                    params: row.id,
                    operate: "adjust",
                    show: type == 1
                },
            ];
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case 'queryFile':
                    this.operate = {
                        title: '查看文件',
                        show: true,
                        width: '460',
                        component: "compUpdate",
                        id:params,
                        showFooter: false,
                        initFormData:{
                            "search[EQ_downloadTaskId]":params
                        }
                    }
                    break;
                case 'queryFileFule':
                    this.operate = {
                        title: '查看文件',
                        show: true,
                        width: '1000',
                        component: "compFule",
                        activeid:params.id,
                        details: params,
                        showFooter: false,
                    }
                    break;
                case 'queryFilePod':
                    this.operate = {
                        title: '查看文件',
                        show: true,
                        width: '800',
                        component: "compPod",
                        activeid: params,
                        showFooter: false,
                    }
                    break;
                case 'export':
                    this.operate = {
                        title: '任务下载',
                        show: true,
                        width: '460',
                        component: "compDown",
                        id:params,
                        showFooter: false,
                    }
                    break;
                case 'adjust':
                    this.operate = {
                        show: true,
                        alert: 'warning',
                        params: { id: params },
                        title: this.$t('fbb.alloment.button_audit', { defaultValue: "审核" }),
                        ajaxRequest: HttpAdjustOne,
                        desc: '审核完成后，将最新的燃油费新增至所有下属组织数据中，请谨慎处理！',
                    }
                    break;
                case "importBatch":
                    this.operate = {
                        show: true,
                        alert: "info",
                        title: this.$t('fbb.alloment.import_data', { defaultValue: '导入数据' }),
                        width: 460,
                        params: {
                            taskIds: params.split(',')
                        },
                        ajaxRequest: HttpTaskBatchImport,
                    };
                    break;
                case "approveBatch":
                    this.operate = {
                        show: true,
                        alert: "info",
                        title: this.$t('fbb.alloment.button_audit', { defaultValue: "审核" }),
                        width: 460,
                        params: {
                            ids: params.split(',')
                        },
                        ajaxRequest: HttpTaskBatchApprove,
                    };
                    break;
            }
        },

    },
    computed: {
        ...mapGetters('dictionary', ['getBillcusorgList', 'getCarrierAllList', 'getCarrierServiceAllList']),
        ToolsData() {
            return [
                {
                    name: "任务下载",
                    operate: "export",
                    theme: "info",
                    // batch: true,
                },
                {
                    label: this.$t('fbb.alloment.muti_import', { defaultValue: '批量导入' }),
                    operate: "importBatch",
                    more: true,
                    batch: true,
                },
                {
                    name: this.$t('fbb.alloment.muti_audit', { defaultValue: "批量审核" }),
                    operate: "approveBatch",
                    more: true,
                    batch: true,
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: "任务编号",
                    key: 'EQ_taskNo',
                    show: true,
                    tag: 'vInput',
                },
                {
                    label: "任务状态",
                    key: 'EQ_status',
                    tag: 'vSelect',
                    options: this.taskStatusList,
                    show:true,
                },
                {
                    label: this.$t('fbb.expresspackage.service_code', { defaultValue: "承运商" }),
                    tag: 'vSelect',
                    key: 'EQ_carrierCode',
                    options: this.getCarrierAllList.map(item=>{
                        return {
                            value: item.attach.carrierCode,
                            label: item.label
                        }
                    }),
                    props:{
                        filterable:true,
                    },
                    show: true,
                },
                {
                    label: this.$t('ucadm.notice.task',{defaultValue:'任务'})+this.$t('erp.product_channel.type',{defaultValue:'类型'}),
                    tag:'vSelect',
                    key:'EQ_type',
                    options:[
                        {label:'账单任务下载',value:0},
                        {label:'燃油费任务下载',value:1},
                        {label:'发票任务下载',value:2},
                        {label:'POD下载',value:3},
                    ]
                },
                {
                    label: this.$t('fbb.bill.freeze_createdat', { defaultValue: "创建日期" }),
                    tag: 'vDatepicker',
                    style: "width:200px",
                    key: 'BT_createdAt',
                    props: {
                        format: 'yy-mm-dd ~ yy-mm-dd',
                        confirm: false,
                    },
                }
            ]
        },
        columns() {
            return [
                {
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id'
                },
                {
                    title: this.$t('global.common.operate', { defaultValue: "操作" }),
                    width: 100,
                    render: this.getOperateNodes
                },
                {
                    title: '任务编号',
                    key: 'taskNo',
                },
                {
                    title: '国别',
                    render: (h, {row})=>{
                        return row.country || '--'
                    }
                },
                {
                    title: '承运商',
                    key: 'carrierCode',
                },
                {
                    title: '账户',
                    key: 'account',
                    render:(h, {row})=>{
                        if(row.type == 3){
                            let res = [];
                            let obj = JSON.parse(row.account)[0];
                            for(let key in obj){
                                let str = '';
                                if(obj[key] instanceof Array){
                                    str = key + '：' + obj[key].join(',')
                                }else{
                                    str = key + '：' + obj[key]
                                }
                                res.push(str)
                            }
                            return h('div', res.map(item=> {return <div>{item}</div>}))
                        }else{
                            return <div>{row.account}</div>
                        }
                    }
                },
                {
                    title: '任务状态',
                    key: 'status',
                    render: (h, { row }) => this.findRenderLabel(this.taskStatusList, row.status)
                },
                {
                    title: '任务类型',
                    key: 'type',
                    render:(h,{row})=>{
                        return <div>
                            {row.type == 0 ? "账单任务下载":row.type == 1?"燃油费任务下载":row.type == 2?"发票任务下载":"POD下载"}
                        </div>
                    }
                },
                {
                    title: '文件列表',
                    render:(h,{row})=>{
                        return <div>
                            <a v-show={row.type == 0} onClick={this.handleOperates.bind(this, row.id, 'queryFile')}>查看详情</a>
                            <a v-show={row.type == 1 && row.meta} onClick={this.handleOperates.bind(this, row, 'queryFileFule')}>查看详情</a>
                            <a v-show={row.type == 3} onClick={this.handleOperates.bind(this, row.id, 'queryFilePod')}>查看详情</a>
                        </div>
                    }
                },
                {
                    title: '任务异常原因',
                    key: 'errorMsg',
                },
                {
                    title: '任务创建人',
                    key: 'createdName',
                },
                {
                    title: '发票日期',
                    render:(h,{row})=>{
                        return <div>
                            <div>{row.invoiceStartDate || '--'}~{row.invoiceEndDate || '--'}</div>
                        </div>
                    }
                },
                {
                    title: '任务创建时间',
                    key: 'createdAt',
                },
                {
                    title: '任务完成时间',
                    key: 'updatedAt',
                }];
        },
    },
};




